import { useMutation } from "@tanstack/react-query";
import useAuth from "hooks/useAuth";
import { liberarTecnicoTaller } from "../Services/liberarTecnicoTaller";

export default function useLiberarTicketMutation() {
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: ({ ticketId, countryId }) =>
      liberarTecnicoTaller({ ticketId, countryId, accessToken }),
  });
}